module.exports = __webpack_public_path__ + "static/media/nav-icon--user.fb5d6060.svg";